import { safeNext } from './safeNext';

export const OAUTH_NEXT_STORAGE_KEY = 'auth_oauth_next_v1';

export function stashOAuthNext(raw: string | null): void {
  try {
    const next = safeNext(raw);
    if (next !== '/') {
      sessionStorage.setItem(OAUTH_NEXT_STORAGE_KEY, next);
    }
  } catch { /* intentionally empty */ }
}

export function consumeOAuthNext(): string | null {
  try {
    const raw = sessionStorage.getItem(OAUTH_NEXT_STORAGE_KEY);
    if (raw == null) {
      return null;
    }
    sessionStorage.removeItem(OAUTH_NEXT_STORAGE_KEY);
    const next = safeNext(raw);
    return next;
  } catch {
    return null;
  }
}
